
class HighlightRotator extends HTMLElement {
  connectedCallback() {
    lazyInit(this, () => {
    window.whenSwiperReady(() => this.init());
  });
  }
 
  init() {
    if (this.initialized) return;
    this.box = this.querySelector('.text_wrap');
    this.el = this.querySelector('.highlight-swiper');
    this.wrapper = this.querySelector('.highlight-wrapper');

    if (!this.el || !this.wrapper) return;

    this.swiper = new Swiper(this.el, {
      direction: 'vertical',
      slidesPerView: 1,
      speed: 600,

      autoplay: {
        delay: 1000,
        disableOnInteraction: false, 
        pauseOnMouseEnter: true
      }
    }); 

    setTimeout(() => {
      this.updateHeightVar();  
    }, 0);

    this.swiper.on('slideChangeTransitionStart', () => {
      this.updateHeightVar();
    });

    window.addEventListener('resize', () => {
      this.updateHeightVar();
    });

    this.initialized = true;
  }

    updateHeightVar() {
      if (!this.box) return;

      const height = this.box.offsetHeight;

      this.wrapper.style.setProperty('--height-box', `${height}px`);
    }

}

customElements.define('highlight-rotator', HighlightRotator);


class ProductPromo extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    window.whenSwiperReady(() => {
      this.init();
    });
  }

  init() {
    const thumbsEl = this.querySelector('.product-thumbs-swiper');
    if (!thumbsEl || thumbsEl.swiper) return;

    const nextBtn = this.querySelector('.swiper-main-button-next');
    const prevBtn = this.querySelector('.swiper-main-button-prev');
    const dotsEl = this.querySelector('.product-promo__dots');

    this.swiper = new Swiper(thumbsEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 800,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      pagination: {
        el: dotsEl,
        clickable: true
      },
      breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 10 },
        370: { slidesPerView: 1.5, spaceBetween: 10 },
        640: { slidesPerView: 3 },
        750: { slidesPerView: 1 }
      },
      observer: true,
      observeParents: true
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this._initialized = false;
  }
}

customElements.define('product-promo', ProductPromo);


class BeforeAfter extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.beforeImg = this.querySelector('.ba_before_img');
    this.afterImg = this.querySelector('.ba_after_img');
    this.slider = this.querySelector('.ba_slider');
    this.thumb = this.slider ? this.slider.querySelector('.ba_thumb') : null;
    this.dragging = false;
    this.currentPos = 0.5;
    this.keyStep = 0.02;

    this._onMouseDown = this.startDrag.bind(this);
    this._onMouseUp = this.stopDrag.bind(this);
    this._onMouseMove = this.onDrag.bind(this);
    this._onTouchStart = this.startDrag.bind(this);
    this._onTouchEnd = this.stopDrag.bind(this);
    this._onTouchMove = this.onDrag.bind(this);
    this._onKeyDown = this.onKeyDown.bind(this);
    this._observer = null;
  }

  connectedCallback() {
    if (!this.slider || !this.thumb || !this.afterImg) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.slider.classList.add('transition');
            this.afterImg.classList.add('transition');
            this.afterImg.classList.add('r_transition');
            this.setPosition(0.5);

            setTimeout(() => {
              this.slider.classList.remove('transition');
              this.afterImg.classList.remove('r_transition');
            }, 600);
          }
        });
      },
      { threshold: 0.5 }
    );
    this._observer = observer;
    observer.observe(this);

    this.thumb.setAttribute('role', 'slider');
    this.thumb.setAttribute('aria-valuemin', '1');
    this.thumb.setAttribute('aria-valuemax', '99');
    this.thumb.setAttribute('aria-orientation', 'horizontal');
    this.thumb.setAttribute('aria-label', 'Compare before and after images');
    this.setAriaValue(this.currentPos);

    this.slider.addEventListener('mousedown', this._onMouseDown);
    window.addEventListener('mouseup', this._onMouseUp);
    window.addEventListener('mousemove', this._onMouseMove);

    this.slider.addEventListener('touchstart', this._onTouchStart);
    window.addEventListener('touchend', this._onTouchEnd);
    window.addEventListener('touchmove', this._onTouchMove);

    this.thumb.addEventListener('keydown', this._onKeyDown);
  }

  startDrag(e) {
    e.preventDefault();
    this.dragging = true;
    this.slider.style.cursor = 'grabbing';
  }

  stopDrag() {
    this.dragging = false;
    this.slider.style.cursor = 'grab';
  }

  
  onDrag(e) {
    if (!this.dragging) return;
    let clientX = e.clientX || (e.touches && e.touches[0].clientX);
    const rect = this.container.getBoundingClientRect();
    let pos = (clientX - rect.left) / rect.width;

    this.setPosition(pos);
  }

  onKeyDown(e) {
    let newPos = this.currentPos;

    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      newPos -= this.keyStep;
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      newPos += this.keyStep;
    } else if (e.key === 'Home') {
      e.preventDefault();
      newPos = 0.01;
    } else if (e.key === 'End') {
      e.preventDefault();
      newPos = 0.99;
    } else {
      return;
    }

    this.setPosition(newPos);
  }

  setPosition(pos) {
    const min = 0.01;
    const max = 0.99;
    const nextPos = Math.max(min, Math.min(max, pos));
    this.currentPos = nextPos;
    this.slider.style.left = `${nextPos * 100}%`;
    this.updateClip(nextPos);
    this.setAriaValue(nextPos);
  }

  setAriaValue(pos) {
    if (!this.thumb) return;
    const value = Math.round(pos * 100);
    this.thumb.setAttribute('aria-valuenow', String(value));
    this.thumb.setAttribute('aria-valuetext', `${value}%`);
  }

  updateClip(pos) {
    this.afterImg.style.clipPath = `inset(0 0 0 ${pos * 100}%)`;
  }

  disconnectedCallback() {
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }

    if (this.slider) {
      this.slider.removeEventListener('mousedown', this._onMouseDown);
      this.slider.removeEventListener('touchstart', this._onTouchStart);
    }

    if (this.thumb) {
      this.thumb.removeEventListener('keydown', this._onKeyDown);
    }

    window.removeEventListener('mouseup', this._onMouseUp);
    window.removeEventListener('mousemove', this._onMouseMove);
    window.removeEventListener('touchend', this._onTouchEnd);
    window.removeEventListener('touchmove', this._onTouchMove);
  }
}

customElements.define('before-after', BeforeAfter);



(function () {

  let lastQuickViewButton = null;
  const drawer = document.getElementById("quick-view-drawer");
  const DRAWER_INPUT_MODALITY_KEY = "__nexusLastInputWasKeyboard";

  if (!drawer) return;

  document.addEventListener("click", function (event) {
    const btn = event.target.closest('[data-quic-drawer="quick-view-drawer"]');
    if (btn) {
      lastQuickViewButton = btn;
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Enter" || event.key === " ") {
      const btn = event.target.closest('[data-quic-drawer="quick-view-drawer"]');
      if (btn) {
        lastQuickViewButton = btn;
      }
    }
  });

  const observer = new MutationObserver(function () {

    const isClosed =
      drawer.getAttribute("aria-hidden") === "true" ||
      drawer.hasAttribute("inert") ||
      !drawer.classList.contains("active");

    const shouldRestoreFocus = window[DRAWER_INPUT_MODALITY_KEY] === true;

    if (isClosed && shouldRestoreFocus && lastQuickViewButton) {

      requestAnimationFrame(() => {
        if (document.contains(lastQuickViewButton)) {
          lastQuickViewButton.focus();
        }
        lastQuickViewButton = null;
      });

    } else if (isClosed && !shouldRestoreFocus) {
      lastQuickViewButton = null;
    }

  });

  observer.observe(drawer, { attributes: true });
   
})();



  class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.currencyForm = this.querySelector('#currency_selector_form');
    this.languageForm = this.querySelector('#language_selector_form');

    this.currencyBtns = this.querySelectorAll('.currency_list button');
    this.languageBtns = this.querySelectorAll('.language_list button');
  }

  connectedCallback() {
    if(this.currencyBtns.length) {
      this.currencyBtns.forEach((btn) => {
        btn.addEventListener('click', this.handleCurrencyClick.bind(this));
      })
    }

    if(this.languageBtns.length) {
      this.languageBtns.forEach((btn) => {
        btn.addEventListener('click', this.handleLanguageClick.bind(this));
      })
    }    
  }

  handleCurrencyClick(e) {
    const value = e.currentTarget.dataset.value;
    this.querySelector('input[name="country_code"]').value = value;
    return;
    this.currencyForm.submit();
  }

  handleLanguageClick(e) {
    const value = e.currentTarget.dataset.value;
    this.querySelector('input[name="language_code"]').value = value;
    return;
    this.languageForm.submit();
  }
}

customElements.define('localization-form', LocalizationForm);

if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.wrapper = this.querySelector('.recipient_fields_wrapper');
        this.inner = this.wrapper.querySelector('.recipient_fields_inner');
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector('.recipient_form_error_msg_wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        const height = this.inner.clientHeight;
        this.wrapper.style.setProperty('--height', `${height}px`);
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
          this.wrapper.classList.add('visible');
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.wrapper.classList.remove('visible');          
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
        }
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
            document.querySelector('.error_message_wrapper').style.display = 'none';            
        
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }
    }
  );
}




class ScrollToTop extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 150) {
        this.classList.add("show");
      } else {
        this.classList.remove("show");
      }
    })

    this.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }
}

customElements.define('scroll-to-top', ScrollToTop);



class ScrollList extends HTMLElement {
  connectedCallback() {
    this.outer = this.querySelector(".scroll-list-outer");
    this.original = this.outer?.querySelector(".sticky_scroll_container");
    if (!this.original) return;

    this.userSpeed = Number(this.dataset.speed) || 100;
    this.direction = -1;
    this.pos = 0;
    this.paused = false;
    this.running = false;

    // Reduced motion
    this.reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (this.reduceMotion) return;

    // Clone once
    this.clone = this.original.cloneNode(true);
    this.clone.classList.add("scroll-clone");
    this.outer.appendChild(this.clone);

    this.width = this.original.getBoundingClientRect().width;
    this.cloneStart = this.width;
    this.speedFactor = this.userSpeed * 0.08;

    // Hover pause
    // this.addEventListener("mouseenter", () => (this.paused = true));
    // this.addEventListener("mouseleave", () => (this.paused = false));

    // Hover pause
    if (this.dataset.pauseOnHover === "true") {
      this.addEventListener("mouseenter", () => (this.paused = true));
      this.addEventListener("mouseleave", () => (this.paused = false));
    }

    // Visibility observer (CRITICAL)
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.start();
        } else {
          this.stop();
        }
      },
      { threshold: 0 }
    );

    this.observer.observe(this);

    // Tab visibility
    document.addEventListener("visibilitychange", () => {
      document.hidden ? this.stop() : this.start();
    });
  }

  start() {
    if (this.running) return;
    this.running = true;
    this.animate();
  }

  stop() {
    this.running = false;
    cancelAnimationFrame(this.raf);
  }

  animate() {
    if (!this.running) return;

    if (!this.paused) {
      this.pos += this.direction * this.speedFactor;
      this.outer.style.transform = `translate3d(${this.pos}px,0,0)`;

      if (this.direction === -1 && Math.abs(this.pos) >= this.cloneStart) {
        this.direction = 1;
      }
      if (this.direction === 1 && this.pos >= 0) {
        this.direction = -1;
      }
    }

    this.raf = requestAnimationFrame(() => this.animate());
  }

  disconnectedCallback() {
    this.stop();
    this.observer?.disconnect();
  }
}

customElements.define("scroll-list", ScrollList);


// VIDEO SECTION
class VideoSection extends HTMLElement {
  constructor() {
    super();
    this.playBtn = this.querySelector('.video_play_btn');
    this.imgWrapper = this.querySelector('.hosted-video-poster_img_wrapper');
    this.vdoWrapper = this.querySelector('.hosted-video-video_wrapper');
    this.video = this.querySelector('video');
    this.iframe = this.querySelector('iframe');
  }

 connectedCallback() {
  this.playBtn.addEventListener('click', this.handleClick.bind(this));

  if (this.video) {
    this.video.setAttribute('tabindex', '-1');
    this.video.setAttribute('aria-hidden', 'true');
    this.video.addEventListener('click', this.handleVdoClick.bind(this));
  }

  if (this.iframe) {
    this.iframe.setAttribute('tabindex', '-1');
    this.iframe.setAttribute('aria-hidden', 'true');
  }
}


 handleClick() {
  if (!this.imgWrapper || !this.vdoWrapper) return;

  this.imgWrapper.classList.add('hide');

  /* Remove play button from tab order */
  this.playBtn.setAttribute('tabindex', '-1');
  this.playBtn.setAttribute('aria-hidden', 'true');

  /* Enable focus on video */
  if (this.video) {
    this.video.removeAttribute('tabindex');
    this.video.removeAttribute('aria-hidden');
    this.video.focus();
    this.video.play();
  } else if (this.iframe) {
    this.iframe.removeAttribute('tabindex');
    this.iframe.removeAttribute('aria-hidden');

    const src = this.iframe.getAttribute("src");

    if (src.includes("youtube")) {
      this.iframe.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        "*"
      );
    } else if (src.includes("vimeo")) {
      this.iframe.contentWindow.postMessage(
        '{"method":"play"}',
        "https://player.vimeo.com"
      );
    }

    this.iframe.focus();
  }
}


  handleVdoClick() {
    if(this.vdoWrapper.classList.contains('controls_enabled')) {} else {
      if(this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }
  }
}

 customElements.define('hosted-video', VideoSection);


class PromotionalPopup extends HTMLElement {
  static get observedAttributes() {
    return ['open'];
  }
 
  connectedCallback() {
    this.overlay = this.querySelector('.promotional_popup_outer');
    this.wrapper = this.querySelector('.promotional_popup_section-id');
    this.closeBtn = this.querySelector('.promotional_popup_close_button button');
    this.noth = this.querySelector('.no_th button');  
    if (!this.wrapper) return; 

    if (this.hasAttribute('open')) {
      requestAnimationFrame(() => this.show());
    } else if (this.shouldAppearAutomatically) {
      setTimeout(() => this.show(), this.delay);
    }

    this.closeBtn?.addEventListener('click', e => {
      e.preventDefault();
      this.hide();
      this.cleanUrl();
    });
    this.noth?.addEventListener('click', e => {
      e.preventDefault();
      this.hide();
    });
  }

  get delay() {
    return Number(this.getAttribute('delay') || 0) * 1000;
  }

  show() {  
    this.overlay.classList.add('show');
    this.wrapper.classList.add('visible');
    this.setAttribute('open', '');
    localStorage.setItem('theme:popup-appeared', 'true');
  }

  hide() { 
    this.overlay.classList.remove('show');
    this.wrapper.classList.remove('visible');
    this.removeAttribute('open');
  }

  cleanUrl() {
    const url = window.location.href
      .replace('?customer_posted=true', '')
      .replace(/(&|\?)$/, '');
    window.history.replaceState({}, document.title, url);
  }

  get shouldAppearAutomatically() {
    if (this.hasAttribute('open')) return false;

    if (localStorage.getItem('theme:popup-filled') === 'true') return false;

    if (
      this.hasAttribute('only-once') &&
      localStorage.getItem('theme:popup-appeared') === 'true'
    ) {
      return false;
    }

    return true;
  }

  attributeChangedCallback(name, oldVal, newVal) {
    if (name === 'open' && newVal !== null) {
      localStorage.setItem('theme:popup-appeared', 'true');
    }
  }
}

customElements.define('promotional-popup', PromotionalPopup);

class QuickViewWrap extends HTMLElement {
  connectedCallback() {
    this.drawer = this.querySelector('#quick-view-drawer');
    if (!this.drawer) return;

    this.initFocusTrap();
    this.observeOpenState();
  }

  observeOpenState() {
    const observer = new MutationObserver(() => {
      if (this.drawer.classList.contains('active')) {
        this.focusFirstElement();
      }
    });

    observer.observe(this.drawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  initFocusTrap() {
    this.drawer.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;

      const focusable = this.getFocusableElements();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first || !this.drawer.contains(document.activeElement)) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  getFocusableElements() {
    return Array.from(
      this.drawer.querySelectorAll(`
        a[href],
        button:not([disabled]),
        textarea:not([disabled]),
        input:not([disabled]),
        select:not([disabled]),
        [tabindex]:not([tabindex="-1"])
      `)
    ).filter(el => el.offsetParent !== null);
  }

  focusFirstElement() {
    requestAnimationFrame(() => {
      const focusable = this.getFocusableElements();
      if (focusable.length) {
        focusable[0].focus();
      }
    });
  }
}

customElements.define('quick-view-wrap', QuickViewWrap); 
 

class QuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.productUrl = this.dataset.productUrl;
    this.mainDrawer = document.querySelector('.quick-view-drawer_wrapper');
    this.drawer = document.querySelector('.quick-view-drawer_inner');

    this.icon = this.querySelector('.icon_wrapper');
    this.loader = this.querySelector('.form_loader');
  }

  connectedCallback() {
    this.attachEvents();
  }

  attachEvents() {
    if (this._eventsAttached) return;
    this._eventsAttached = true;

    this.addEventListener('click', () => {
      this.showLoader();
      this.handleFetch();
    });
  }

  showLoader() {
    this.loader?.classList.remove('hidden');
    this.icon?.classList.add('hidden');
  }

  hideLoader() {
    this.loader?.classList.add('hidden');
    this.icon?.classList.remove('hidden');
  }

  handleFetch() {
    fetch(this.productUrl)
      .then(res => res.text())
      .then(data => {
        const temp = document.createElement('div');
        temp.innerHTML = data;

        const updatedHTML = temp.querySelector('.product-main-inner');
        if (!updatedHTML) {
          this.hideLoader();
          return;
        }

        const productInfo = updatedHTML.querySelector('product-info');
        if (!productInfo) {
          this.hideLoader();
          return;
        }

        const originalSectionId = productInfo.dataset.sectionId;
        const updatedSectionId = `quick-add-${originalSectionId}`;

        updatedHTML.innerHTML = updatedHTML.innerHTML.replaceAll(
          originalSectionId,
          updatedSectionId
        );

        productInfo.dataset.originalSectionId = originalSectionId;
        productInfo.dataset.updateUrl = 'false';

        updatedHTML.querySelectorAll('.accordion_item button')
          .forEach(btn => btn.setAttribute('tabindex', '-1'));

        updatedHTML.querySelector('sticky-cart')?.remove();

        if (this.drawer) {
          this.drawer.innerHTML = updatedHTML.innerHTML;
        }

        setTimeout(() => {
          openDrawer(this.mainDrawer, this);
          this.hideLoader();
        }, 200);
      })
      .catch(() => {
        this.hideLoader();
      });
  }
} 
customElements.define('quick-add-button', QuickAddButton);


class StickyCart extends HTMLElement {
  constructor() {
    super();
    this.mainBtn = this.closest('product-info')?.querySelector('.add_to_cart_button');
    this.footerWrapper = document.querySelector('.footer_outer');
    this.stickyWrapper = this.querySelector('.product-sticky-wrap');

    this.observerMainButton = null;
    this.observerFooter = null;

    this.mainBtnVisible = true;
    this.footerVisible = false;
    this.hasScrolledEnough = false;

    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    if (!this.stickyWrapper || !this.footerWrapper) return;

    this.initObservers();
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    this.closest('product-info')?.addEventListener('variant-change', () => {
      this.initObservers();
    });

    this.handleScroll(); // initial check
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    this.observerMainButton?.disconnect();
    this.observerFooter?.disconnect();
  }

  handleScroll() {
    this.hasScrolledEnough = window.scrollY >= 900;
    this.updateSticky();
  }

  initObservers() {
    this.observerMainButton?.disconnect();

    const mainBtn = this.closest('product-info')?.querySelector('.add_to_cart_button');
    if (!mainBtn) return;

    this.observerMainButton = new IntersectionObserver(
      ([entry]) => {
        this.mainBtnVisible = entry.isIntersecting;
        this.updateSticky();
      },
      { threshold: 0 }
    );
    this.observerMainButton.observe(mainBtn);

    if (!this.observerFooter && this.footerWrapper) {
      this.observerFooter = new IntersectionObserver(
        ([entry]) => {
          this.footerVisible = entry.isIntersecting;
          this.updateSticky();
        },
        { threshold: 0 }
      );
      this.observerFooter.observe(this.footerWrapper);
    }
  }

  updateSticky() {
    if (
      !this.mainBtnVisible &&
      !this.footerVisible &&
      this.hasScrolledEnough
    ) {
      this.stickyWrapper.classList.add('active');
    } else {
      this.stickyWrapper.classList.remove('active');
    }
  }
}

customElements.define('sticky-cart', StickyCart);


class PickupAvailabilityDrawer extends HTMLElement {
  connectedCallback() {
    this.inner = this.querySelector(".drawer-wrapper_inner");

    this.handleKeydown = this.handleKeydown.bind(this);

    this.addEventListener("click", (e) => {
      const closeBtn = e.target.closest(".drawer_close_btn");

      if (closeBtn) {
        e.preventDefault();
        this.closeDrawer();
        return;
      }

      if (this.inner && !this.inner.contains(e.target)) {
        this.closeDrawer();
      }
    });

    this.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.closeDrawer();
      }
    });

    // Apply focus trap immediately if active
    if (this.classList.contains("active")) {
      this.activateTrap();
    }

    // Watch only for active state changes
    this.stateObserver = new MutationObserver(() => {
      if (this.classList.contains("active")) {
        this.activateTrap();
      } else {
        this.deactivateTrap();
      }
    });

    this.stateObserver.observe(this, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  activateTrap() {
    if (!this.inner) return;

    this.focusableSelectors =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    this.addEventListener("keydown", this.handleKeydown);

    // Focus first element
    const focusables = this.getFocusableElements();
    if (focusables.length) {
      focusables[0].focus();
    }
  }

  deactivateTrap() {
    this.removeEventListener("keydown", this.handleKeydown);
  }

  getFocusableElements() {
    if (!this.inner) return [];
    return [...this.inner.querySelectorAll(this.focusableSelectors)]
      .filter(el => !el.disabled && el.offsetParent !== null);
  }

  handleKeydown(e) {
    if (e.key !== "Tab") return;

    const focusables = this.getFocusableElements();
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  closeDrawer() {
    if (!this.classList.contains("active")) return;

    this.classList.remove("active");
    this.setAttribute("aria-hidden", "true");
    document.body.classList.remove("overflow-hidden");

    window.whenLenisReady((lenis) => {
      lenis.start();
    });
  }

  disconnectedCallback() {
    if (this.stateObserver) {
      this.stateObserver.disconnect();
    }
    this.deactivateTrap();
  }
}

customElements.define("pickup-availability-drawer", PickupAvailabilityDrawer);


class PickupAvailabilityPreview extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", (e) => {
      const btn = e.target.closest(".drawer_open_btn");
      if (!btn) return;

      e.preventDefault();

      const drawerId = btn.dataset.drawer;
      if (!drawerId) return;

      const drawer = document.getElementById(drawerId);
      if (!drawer) return;

      this.openDrawer(drawer, btn);
    });
  }

  openDrawer(drawer, trigger) {
    drawer.classList.add("active");
    drawer.setAttribute("aria-hidden", "false");

    document.body.classList.add("overflow-hidden");

    drawer.focus({ preventScroll: true });

    window.whenLenisReady(lenis => {
    lenis.start();
  });

  }
} 

customElements.define("pickup-availability-preview", PickupAvailabilityPreview);



class SizeChart extends HTMLElement {   
  connectedCallback() { 
    this.trigger = this.querySelector(".size_chart_wrapper");
    this.popup = document.querySelector(".size_chart_popup_wrapper");
    
    if (!this.trigger || !this.popup) return;
   
    this.inner = this.popup.querySelector(".size_chart_popup_inner");
    this.closeBtn = this.popup.querySelector(".size_chart_popup_close");
    this.sections = document.querySelectorAll(".shopify-section");

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);

    this.trigger.addEventListener("click", this.open);
    this.popup.addEventListener("click", this.close);
    this.inner?.addEventListener("click", this.stopPropagation);
    this.closeBtn?.addEventListener("click", this.close);
  }

  open(e) {
    e.preventDefault();

    this.popup.classList.add("active");

    this.sections.forEach((section) => {
      section.style.zIndex = "unset";
    });

    document.body.setAttribute("data-scroll-locked", "true");
    window.whenLenisReady(lenis => {
    lenis.start();
  });

  }

  close() {
    this.popup.classList.remove("active");

    this.sections.forEach((section) => {
      section.style.zIndex = "0";
    });

    const header = document.querySelector(
      ".shopify-section-group-header-group.header-section"
    );
    const announcement = document.querySelector(
      ".shopify-section-group-header-group.announcement-bar"
    );

    if (header) header.style.zIndex = "4";
    if (announcement) announcement.style.zIndex = "4";

    document.body.removeAttribute("data-scroll-locked");
    window.whenLenisReady(lenis => {
    lenis.start();
  });

  }

  stopPropagation(e) {
    e.stopPropagation();
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener("click", this.open);
    this.popup?.removeEventListener("click", this.close);
    this.inner?.removeEventListener("click", this.stopPropagation);
    this.closeBtn?.removeEventListener("click", this.close);
  }
}
 
customElements.define("size-chart", SizeChart); 



class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.recommendedURL = this.dataset.url;
    this.spacing = Number(this.dataset.spacing);
    this.columns = Number(this.dataset.columns);
    this.mobColumns = Number(this.dataset.mobColumns);
    this.tabColumns = Number(this.dataset.tabColumns);
    this.midColumns = Number(this.dataset.midColumns);
  }

  connectedCallback() {
    this.loadRecommendedProducts(
      this.recommendedURL,
      this.productId,
      this.sectionId
    );
  }

  loadRecommendedProducts(recommendedURL, productId, sectionId) {
    fetch(`${recommendedURL}&product_id=${productId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((data) => {
        const html = document.createElement("div");
        html.innerHTML = data;

        const recommendedProducts = html.querySelector("product-recommendations");

        if (recommendedProducts?.innerHTML.trim().length) {
          this.innerHTML = recommendedProducts.innerHTML;

          this.productsInner =
            this.querySelector(".product_recommendations_inner") ||
            this.querySelector(".complementary_products_inner");

          this.initRecommendedSlider();
          document.dispatchEvent(new CustomEvent("RecommendedProductsUpdated"));
        }
      });
  }

  initRecommendedSlider() {
  const inner = this.productsInner;
  const spacing = this.spacing;

  const prevBtn = this.querySelector('.swiper-button-prev');
  const nextBtn = this.querySelector('.swiper-button-next');
  const scrollbar = this.querySelector('.swiper-scrollbar');

  new Swiper(inner, {
    slidesPerView: this.columns,
    spaceBetween: spacing,

    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },

    scrollbar: {
      el: scrollbar,
      draggable: true,
      hide: false,
    },

    breakpoints: {
      0: {
        slidesPerView: this.mobColumns,
        spaceBetween: spacing
      },
      640: {
        slidesPerView: this.columns,
        spaceBetween: spacing
      },
      768: {
        slidesPerView: this.tabColumns,
        spaceBetween: spacing
      },
      1280: {
        slidesPerView: this.midColumns,
        spaceBetween: spacing
      },
      1399: {
        slidesPerView: this.columns,
        spaceBetween: spacing
      }
    }
  });
}

}

customElements.define("product-recommendations", ProductRecommendations);

// Cart Cross-sell

class CartCrossSell extends HTMLElement {
  constructor() {
    super();
    this.limit = Number(this.dataset.limit) || 8;
    this.perView = Number(this.dataset.perView) || 2.2;
    this.recommendationsUrl = this.dataset.recommendationsUrl;
  }

  connectedCallback() {
    this.wrap = this.querySelector(".cart-cross-sell__inner");
    this.wrapperEl = this.querySelector(".cart-cross-sell__wrapper");
    this.addEventListener("click", this.handleClick.bind(this));
    this.load();
  }

  handleClick(e) {
    const btn = e.target.closest(".cart-cross-sell__add[data-variant-id]");
    if (!btn) return;
    e.preventDefault();
    this.addToCart(btn);
  }

  load() {
    fetch(window.Shopify.routes.root + "cart.js")
      .then((res) => res.json())
      .then((cart) => this.buildRecommendations(cart))
      .catch(() => this.hide());
  }

  buildRecommendations(cart) {
    if (!cart.items || !cart.items.length) {
      this.hide();
      return;
    }

    const cartProductIds = [...new Set(cart.items.map((item) => item.product_id))];
    // Most recent distinct products first, capped to limit request count
    const sourceIds = cartProductIds.slice(-3).reverse();

    Promise.all(
      sourceIds.map((id) =>
        fetch(`${this.recommendationsUrl}.json?product_id=${id}&limit=${this.limit}&intent=related`)
          .then((res) => res.json())
          .then((data) => data.products || [])
          .catch(() => [])
      )
    ).then((results) => {
      const seen = new Set(cartProductIds);
      const merged = [];

      results.flat().forEach((product) => {
        if (!seen.has(product.id) && merged.length < this.limit) {
          seen.add(product.id);
          merged.push(product);
        }
      });

      if (!merged.length) {
        this.hide();
        return;
      }

      this.renderCards(merged);
    });
  }

  hide() {
    if (this.wrap) this.wrap.setAttribute("hidden", "");
  }

  renderCards(products) {
    this.wrapperEl.innerHTML = products.map((p) => this.cardHTML(p)).join("");
    this.wrap.removeAttribute("hidden");
    this.initSwiper(products.length);
  }

  cardHTML(p) {
    const variant = p.variants && p.variants[0];
    const singleVariant = p.variants && p.variants.length === 1;
    const canQuickAdd = singleVariant && variant && variant.available;
    const priceHTML = p.price_varies ? `From ${this.money(p.price_min)}` : this.money(p.price);

    const compareAt = p.compare_at_price_max || p.compare_at_price;
    const showCompare = compareAt && compareAt > p.price;
    const compareHTML = showCompare
      ? `<s class="cart-cross-sell__compare-price">${this.money(compareAt)}</s>`
      : "";

    return `
      <div class="swiper-slide cart-cross-sell__slide">
        <a href="${p.url}" class="cart-cross-sell__link">
          <div class="cart-cross-sell__image-wrap">
            ${p.featured_image ? `<img src="${p.featured_image}&width=300" alt="${this.escape(p.title)}" loading="lazy" class="cart-cross-sell__image">` : ""}
          </div>
          <div class="cross_sell_meta">
            <p class="cart-cross-sell__title">${this.escape(p.title)}</p>
            <p class="cart-cross-sell__price">${priceHTML} ${compareHTML}</p>
          </div>
        </a>
        ${
          canQuickAdd
            ? `<button type="button" class="btn btn-primary cart-cross-sell__add" data-variant-id="${variant.id}"><span class="atc_text btn-txt">Add to cart</span></button>`
            : `<a href="${p.url}" class="btn btn-primary cart-cross-sell__add"><span class="atc_text btn-txt">View options</span></a>`
        }
      </div>
    `;
  }

  money(cents) {
    try {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    } catch (e) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  escape(str) {
    const div = document.createElement("div");
    div.textContent = str || "";
    return div.innerHTML;
  }

  initSwiper(count) {
    if (!window.Swiper) return;
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }

    const canSwipe = count > 1;

    this.swiper = new Swiper(this.wrapperEl.closest(".cart-cross-sell__track"), {
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 12,
      speed: 400,
      watchOverflow: true,
      allowTouchMove: canSwipe,
      resistanceRatio: 0,

      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1024: {
          slidesPerView: 3
        }
      }
    });
  }

  addToCart(btn) {
    const variantId = btn.getAttribute("data-variant-id");
    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Adding...";

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) {
          throw new Error(data.description || data.message || "Could not add to cart");
        }
        return fetch(window.Shopify.routes.root + "?sections=cart-drawer,cart-count,cart-main");
      })
      .then((res) => res.json())
      .then((sections) => {
        document.dispatchEvent(
          new CustomEvent("cart-update", {
            detail: { sections, button: btn },
            bubbles: true
          })
        );
        // Note: the element above is about to be replaced by the cart-update
        // swap this same event triggers, so no need to reset button state here.
      })
      .catch(() => {
        btn.textContent = "Error - try again";
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      });
  }
}

customElements.define("cart-cross-sell", CartCrossSell);

class AccordionTab extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.accordion_item');
  }

  connectedCallback() {
    this.section = this.closest('.shopify-section');
    this.initializeAccordions();
  }

  initializeAccordions() {
    if (!this.items.length || !this.section) return;

    this.items.forEach(item => {
      const header = item.querySelector('.accordion_header');
      const content = item.querySelector('.accordion_content');

      if (!header || !content) return;

      // Preserve default open state
      if (item.classList.contains('open')) {
        content.style.height = `${content.scrollHeight}px`;
      } else {
        content.style.height = '0px';
      }

      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');

        // Close ALL other accordions in the SAME section
        this.section
          .querySelectorAll('.accordion_item.open')
          .forEach(otherItem => {
            if (otherItem !== item) {
              const otherContent = otherItem.querySelector('.accordion_content');
              if (otherContent) {
                this.closeAccordion(otherItem, otherContent);
              }
            }
          });

        // Toggle current accordion
        if (isOpen) {
          this.closeAccordion(item, content);
        } else {
          this.openAccordion(item, content);
        }
      });
    });
  }

  openAccordion(item, content) {
    content.style.height = `${content.scrollHeight}px`;
    item.classList.add('open');
  }

  closeAccordion(item, content) {
    content.style.height = '0px';
    item.classList.remove('open');
  }
}

customElements.define('accordion-tab', AccordionTab);


class ProductQuiz extends HTMLElement {
  constructor() {
    super();
    this.thumbs = null;
    this.preview = null;
    this.recommendation = null;
    this.handleResize = null;
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    lazyInit(this, () => {
    window.whenSwiperReady(() => this.init());
  });
  }

  init() {
    const thumbsEl = this.querySelector('.quiz-product-thumbs-swiper');
    const previewEl = this.querySelector('.product-preview-swiper');
    const nextBtn = this.querySelector('.product-quiz__next');
    const prevBtn = this.querySelector('.product-quiz__prev');
    const submitBtn = this.querySelector('.product-quiz__submit');

    if (!thumbsEl || !previewEl) return;

    this.thumbs = new Swiper(thumbsEl, {
      slidesPerView: 1,
      spaceBetween: 15,
      allowTouchMove: false,
      autoHeight: false,
      observer: true,
      observeParents: true,
      pagination: {
        el: this.querySelector('.options-pagination'),
        clickable: true,
      },
    });

    this.preview = new Swiper(previewEl, {
      slidesPerView: 1,
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      observer: true,
      observeParents: true,
    });

    this.thumbs.controller.control = this.preview;
    this.preview.controller.control = this.thumbs;

    const recSliderEl = this.querySelector('.product-recommendation-swiper');
    if (recSliderEl) this.initRecommendationSlider();

    this.setupQuizOptionBehavior();

    nextBtn?.addEventListener('click', (e) => this.handleNextSlide(e));
    prevBtn?.addEventListener('click', () => this.thumbs.slidePrev());
    submitBtn?.addEventListener('click', (e) => this.handleSubmitQuiz(e));

    this.updateNavigationState();

    this.thumbs.on('slideChange', () => {
      this.updateNavigationState();
      this.updateAutoHeight();

      const active = this.thumbs.slides[this.thumbs.activeIndex];
      if (active?.classList.contains('quiz-recommendation-slide')) {
        this.filterRecommendations(this.getAnswerNumberString());
      }
    });

    this.handleResize = () => this.updateAutoHeight();
    window.addEventListener('resize', this.handleResize, { passive: true });
  }

  updateAutoHeight() {
    if (!this.thumbs) return;

    requestAnimationFrame(() => {
      this.thumbs.update();
      this.thumbs.updateAutoHeight(300);
    });
  }

  initRecommendationSlider() {
    const el = this.querySelector('.product-recommendation-swiper');
    if (!el) return;

    this.recommendation = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 15,
      allowTouchMove: true,
      autoHeight: false,
      observer: true,
      observeParents: true,
      pagination: {
        el: this.querySelector('.product-recommendation-pagination'),
        clickable: true,
      },
    });
  }

  setupQuizOptionBehavior() {
    this.querySelectorAll('.swiper-slide').forEach((slide) => {
      const options = slide.querySelectorAll('.quiz-option-btn');

      options.forEach((btn) => {
        btn.addEventListener('click', () => {
          options.forEach((b) => b.classList.remove('quiz-selected'));
          btn.classList.add('quiz-selected');
          this.updateAutoHeight();
        });
      });
    });
  }

  getAnswerNumberString() {
    return [...this.querySelectorAll('.quiz-option-btn.quiz-selected')]
      .map(btn => btn.getAttribute('option_number'))
      .join('+');
  }

  filterRecommendations(answerString) {
    const slides = this.querySelectorAll(
      '[data-rec-wrapper] .swiper-slide.outer_slide_recommend'
    );

    slides.forEach(sl => sl.classList.remove('matched', 'unmatched'));

    const matched = [];

    slides.forEach((slide) => {
      const combos = (slide.getAttribute('data-match') || '')
        .split(',')
        .map(v => v.trim())
        .filter(Boolean);

      if (combos.includes(answerString)) matched.push(slide);
    });

    if (!matched.length) {
      slides.forEach((sl, i) => i < 3 && sl.classList.add('matched'));
    } else {
      matched.forEach(sl => sl.classList.add('matched'));
      slides.forEach(sl => {
        if (!sl.classList.contains('matched')) {
          sl.classList.add('unmatched');
        }
      });
    }

    this.recommendation?.update();
    this.updateAutoHeight();
  }

  handleNextSlide(e) {
    e.preventDefault();

    const slide = this.thumbs.slides[this.thumbs.activeIndex];
    const selected = slide?.querySelector('.quiz-option-btn.quiz-selected');
    const isResult = slide?.classList.contains('quiz-recommendation-slide');

    if (!selected && !isResult) {
      slide?.classList.add('quiz-error');
      setTimeout(() => slide?.classList.remove('quiz-error'), 800);
      return;
    }

    if (this.thumbs.activeIndex < this.thumbs.slides.length - 1) {
      this.thumbs.slideNext();
    }
  }

  handleSubmitQuiz(e) {
    e.preventDefault();

    const resultIndex = this.thumbs.slides.length - 1;
    const lastQuestionIndex = resultIndex - 1;

    if (this.thumbs.activeIndex !== lastQuestionIndex) return;

    const slide = this.thumbs.slides[this.thumbs.activeIndex];
    const selected = slide?.querySelector('.quiz-option-btn.quiz-selected');

    if (!selected) {
      slide?.classList.add('quiz-error');
      setTimeout(() => slide?.classList.remove('quiz-error'), 800);
      return;
    }

    this.thumbs.slideTo(resultIndex);
  }

  updateNavigationState() {
    if (!this.thumbs) return;

    const prevBtn = this.querySelector('.product-quiz__prev');
    const nextBtn = this.querySelector('.product-quiz__next');
    const submitBtn = this.querySelector('.product-quiz__submit');

    if (!prevBtn || !nextBtn || !submitBtn) return;

    const activeIndex = this.thumbs.activeIndex;
    const resultIndex = this.thumbs.slides.length - 1;
    const lastQuestionIndex = resultIndex - 1;
    const isResultSlide = activeIndex === resultIndex;
    const isLastQuestion = activeIndex === lastQuestionIndex;

    prevBtn.disabled = activeIndex === 0;

    if (isResultSlide) {
      nextBtn.classList.add('hidden');
      submitBtn.classList.add('hidden');
      return;
    }

    if (isLastQuestion) {
      nextBtn.classList.add('hidden');
      submitBtn.classList.remove('hidden');
    } else {
      submitBtn.classList.add('hidden');
      nextBtn.classList.remove('hidden');
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    this.thumbs?.destroy(true, true);
    this.preview?.destroy(true, true);
    this.recommendation?.destroy(true, true);
    this._initialized = false;
  }
}

customElements.define('product-quiz', ProductQuiz);


class CountdownProducts extends HTMLElement {
  connectedCallback() {
    if (this.dataset.slider !== "true") return;

    const container = this.querySelector(".countdown-swiper");
    if (!container) return;

    const scrollbarEl = this.querySelector(".swiper-scrollbar");
    const nextBtn = this.querySelector(".swiper-button-next");
    const prevBtn = this.querySelector(".swiper-button-prev");
    const cols = parseFloat(this.dataset.cols) || 3;

    window.whenSwiperReady(() => {
      if (this._swiper) return;

      this._swiper = new Swiper(container, {
        slidesPerView: cols,
        spaceBetween: 24,
        loop: false,

        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },

        scrollbar: {
          el: scrollbarEl,
          draggable: true
        },

        breakpoints: {
          0: { slidesPerView: 1, spaceBetween: 10 },
          350: { slidesPerView: 1.3, spaceBetween: 10 },
          640: { slidesPerView: 1, spaceBetween: 20 },
          800: { slidesPerView: 2, spaceBetween: 20 },
          1400: { slidesPerView: cols, spaceBetween: 20 }
        }
      });
    });
  }

  disconnectedCallback() {
    this._swiper?.destroy(true, true);
    this._swiper = null;
  }
}

customElements.define("countdown-products", CountdownProducts);

class DealCountdown extends HTMLElement {
  connectedCallback() {
    const endDateStr = this.dataset.end;

    this.daysEl = this.querySelector('[data-unit="days"]');
    this.hoursEl = this.querySelector('[data-unit="hours"]');
    this.minutesEl = this.querySelector('[data-unit="minutes"]');
    this.secondsEl = this.querySelector('[data-unit="seconds"]');

    let parsed = new Date(endDateStr);
    let time = parsed.getTime();

    if (!endDateStr || isNaN(time)) {
      this.endTime = null;
    } else {
      this.endTime = time;
    }

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  update() {
    if (!this.endTime) {
      this.setZero();
      return;
    }

    const now = Date.now();
    let diff = this.endTime - now;

    if (diff <= 0 || isNaN(diff)) {
      this.setZero();
      clearInterval(this.interval);
      return;
    }

    const d = Math.floor(diff / (1000 * 60 * 60 * 24));
    const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const m = Math.floor((diff / 1000 / 60) % 60);
    const s = Math.floor((diff / 1000) % 60);

    this.daysEl.textContent = String(d).padStart(2, '0');
    this.hoursEl.textContent = String(h).padStart(2, '0');
    this.minutesEl.textContent = String(m).padStart(2, '0');
    this.secondsEl.textContent = String(s).padStart(2, '0');
  }

  setZero() {
    this.daysEl.textContent = '00';
    this.hoursEl.textContent = '00';
    this.minutesEl.textContent = '00';
    this.secondsEl.textContent = '00';
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }
}

customElements.define('deal-countdown', DealCountdown);

class BeforeAfterTab extends HTMLElement {
  constructor() {
    super();
    this.scrollHandler = null;
    this.section = null;
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('.bf-tab-btn');
    this.slides = this.querySelectorAll('.before-af-show');
    this.products = this.querySelectorAll('.bf_product_slide');

    if (!this.buttons.length) return;

    this.section = this.closest('.stacked-scroll-section');

    this.init();
  }

  init() {
    this.setActive(0);

    this.buttons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        this.setActive(index);
      });
    });

    this.bindScroll();
  }

  setActive(index) {
    this.buttons.forEach((btn, i) => {
      btn.classList.toggle('active', i === index);
    });

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });

    this.products.forEach((product, i) => {
      product.classList.toggle('active', i === index);
    });
  }

    bindScroll() {
    if (!this.section) return;

    const totalItems = this.buttons.length;
    let ticking = false;
    let currentIndex = -1;

    const update = () => {
      const rect = this.section.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      const sectionTop = rect.top;
      const sectionHeight = rect.height;

      const totalScroll = sectionHeight - viewportHeight;

      if (totalScroll <= 0) return;

      let progress = (-sectionTop) / totalScroll;
      progress = Math.max(0, Math.min(1, progress));

      const rawIndex = progress * totalItems;
      const index = Math.min(totalItems - 1, Math.floor(rawIndex));

      if (index !== currentIndex) {
        currentIndex = index;
        this.setActive(index);
      }

      ticking = false;
    };

    this.scrollHandler = () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    };

    window.addEventListener('scroll', this.scrollHandler, { passive: true });
    window.addEventListener('resize', this.scrollHandler);

    update();
  }

  disconnectedCallback() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('resize', this.scrollHandler);
    }
  }
}

customElements.define('beforeafter-tab', BeforeAfterTab);

const PARALLAX_SELECTOR = "[data-animation]",
DISABLED_CLASS = "is-disabled",
MAIN_CONTENT_CLASS = "main-content",
SECTION_CLASS = "shopify-section",
PARALLAX_ATTR = "data-animation",
INTENSITY_ATTR = "data-animation-intensity",
STATIC_ATTR = "data-parallax-static",
SINGLE_ATTR = "data-parallax-single",
DISABLE_MOBILE_ATTR = "data-parallax-disable-on-mobile";

function getOrientation() {
	return window.innerWidth > window.innerHeight ? "landscape" : "portrait"
}

class ParallaxHandler {
	constructor(container) {
    this.container = container, this.percentage = 0, this.percentageFull = 0, this.animation = container.getAttribute("data-animation"), this.disableOnMobile = container.hasAttribute("data-animation-disable-on-mobile"), this.viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0), this.orientation = this.getOrientation(), this.scrollEvent = () => this.updateParallax(), this.resizeEvent = () => this.updateHeight(), this.lenisScrollEvent = () => this.updateParallax(), this.container.style.setProperty("--transformX-primary", "0%"), this.container.style.setProperty("--transformY-primary", "0%"), this.container.style.setProperty("--transformX-secondary", "0%"), this.container.style.setProperty("--transformY-secondary", "0%"), requestAnimationFrame(() => {
			this.containerHeight = container.offsetHeight, this.footerOffset = .15 * this.containerHeight, this.cachedPosition = this.footerOffset, this.cachedPercentage = 0, this.init()
		})
	}
	init() {
    this.updateParallax(), document.addEventListener("theme:scroll", this.scrollEvent), document.addEventListener("theme:resize", this.resizeEvent), document.addEventListener("theme:load", this.resizeEvent), window.whenLenisReady && window.whenLenisReady(lenis => {
      lenis && typeof lenis.on == "function" && lenis.on("scroll", this.lenisScrollEvent)
    })
	}
	unload() {
    document.removeEventListener("theme:scroll", this.scrollEvent), document.removeEventListener("theme:resize", this.resizeEvent), document.removeEventListener("theme:load", this.resizeEvent), window.lenis && typeof window.lenis.off == "function" && window.lenis.off("scroll", this.lenisScrollEvent)
	}
	updateParallax() {
		if (this.container.classList.contains("is-disabled") || this.disableOnMobile && this.isMobile()) return;
    const scrollTop = window.scrollY || window.pageYOffset || 0,
			scrollBottom = scrollTop + this.viewportHeight;
    let containerTop = this.container.getBoundingClientRect().top + scrollTop;
		if (this.animation === "footer") {
			let sibling = document.getElementById("MainContent");
			sibling && (containerTop = Math.round(sibling.getBoundingClientRect().bottom + scrollTop))
		}
		const containerHeight = this.container.offsetHeight;
		if (containerTop < scrollBottom && containerTop + containerHeight >= scrollTop) {
      const visibleBottom = scrollBottom - containerTop;
      switch (this.percentage = 100 * (visibleBottom - containerHeight / 2) / this.viewportHeight, this.percentageFull = Number((visibleBottom / containerHeight).toFixed(2)), this.percentageVisible = Number((100 * visibleBottom / (this.viewportHeight + containerHeight)).toFixed(2)), this.animation) {
				case "circle":
					this.animateCircleText();
					break;
				case "horizontal":
				case "vertical":
				case "diagonal":
					this.animateOverlappingImages();
					break;
				case "offset-ltr":
				case "offset-rtl":
					this.applyOffsetX();
					break;
				case "zoom-on-scroll":
					this.zoomInOut();
					break;
				case "fade-in":
					this.fadeInOnScroll();
					break;
				case "blur":
					this.blurOutUntilCenter();
					break;
				case "footer":
					this.animateFooter();
					break
			}
		}
	}
	applyOffsetX() {
		const isStatic = this.container.hasAttribute("data-animation-static"),
      intensity = this.getIntensity();
		let baseOffset = this.animation === "offset-ltr" ? intensity : 0;
		isStatic && (baseOffset = intensity / 2);
		const direction = this.animation === "offset-ltr" ? 1 : -1,
			offset = intensity * this.percentageVisible / 100 - baseOffset;
		let finalOffset = Number(offset * direction).toFixed(2);
		finalOffset = Math.max(0, Math.min(1, finalOffset));
		const clamp = (n, min, max) => Math.max(min, Math.min(max, n)),
			value = 1 - clamp((this.percentageVisible - 40) / 60, 0, 1),
			scaleValue = 1.5 - clamp(this.percentageVisible, 0, 100) / 100;
		this.container.style.setProperty("--offsetX", `${value*1.2}`), this.container.style.setProperty("--scale", `${scaleValue*1.5}`)
	}
  getIntensity() {
    const raw = Number(this.container.getAttribute("data-animation-intensity"));
    return Number.isFinite(raw) ? raw : 100
  }
	animateCircleText() {
		const rotateAmount = 70 * this.percentage / 100 * 1;
		this.percentage > 0 && this.container.style.setProperty("--rotate", `${35+rotateAmount}deg`)
	}
	animateOverlappingImages() {
    const intensity = .25 * this.getIntensity(),
			halfIntensity = intensity / 2,
			isSingle = this.container.hasAttribute("data-animation-single"),
			value = intensity * this.percentage / 100;
		let xPrimary = 0,
			yPrimary = 0,
			xSecondary = 0,
			ySecondary = 0;
		["horizontal", "diagonal"].includes(this.animation) && (xPrimary = -halfIntensity + value, xSecondary = halfIntensity - value), ["vertical", "diagonal"].includes(this.animation) && (yPrimary = halfIntensity - value, ySecondary = -halfIntensity + value), this.container.style.setProperty("--transformX-primary", `${xPrimary}%`), this.container.style.setProperty("--transformY-primary", `${yPrimary}%`), isSingle || (this.container.style.setProperty("--transformX-secondary", `${xSecondary}%`), this.container.style.setProperty("--transformY-secondary", `${ySecondary}%`))
	}
	animateFooter() {
		const offset = this.footerOffset * this.percentageFull,
			percentage = Number(offset / this.footerOffset * 100).toFixed(2);
		let newY = Number(this.footerOffset - offset).toFixed(2);
		this.percentageFull >= 1 && (newY = 0), this.cachedPercentage !== percentage && (this.container.style.setProperty("--transformY", `${newY}`), this.cachedPercentage = percentage, this.cachedPosition = newY)
	}
	zoomInOut() {
		const scale = 1 + .2 * this.percentageVisible / 100,
			clampedScale = Math.max(scale, 1);
		this.container.style.setProperty("--scale", clampedScale.toFixed(4))
	}
	fadeInOnScroll() {
		const viewportCenter = this.viewportHeight / 2,
			rect = this.container.getBoundingClientRect(),
			start = this.viewportHeight,
			end = viewportCenter - rect.height / 2,
			current = rect.top;
		let progress = (start - current) / (start - end);
		progress = Math.max(0, Math.min(1, progress)), this.container.style.setProperty("--opacity", progress.toFixed(4))
	}
	blurOutUntilCenter() {
		const viewportCenter = this.viewportHeight / 2,
			rect = this.container.getBoundingClientRect(),
			start = this.viewportHeight,
			end = viewportCenter - rect.height / 2,
			current = rect.top;
		let progress = (start - current) / (start - end);
		progress = Math.max(0, Math.min(1, progress));
		const blur = (1 - progress) * 10;
		this.container.style.setProperty("--blur", `${blur.toFixed(2)}px`)
	}
	updateHeight() {
		const isDesktop = matchMedia("(min-width: 1024px)").matches;
		(this.orientation !== this.getOrientation() || isDesktop) && (this.viewportHeight = Math.round(Math.max(document.documentElement.clientHeight, window.innerHeight || 0)), this.containerHeight = this.container.offsetHeight, this.orientation = this.getOrientation())
	}
	getOrientation() {
		return window.innerWidth > window.innerHeight ? "landscape" : "portrait"
	}
	isMobile() {
		return /Mobi|Android/i.test(navigator.userAgent)
	}
}
window.ParallaxHandler = ParallaxHandler;


window.addEventListener("scroll", () => {
  document.dispatchEvent(new Event("theme:scroll"));
});

window.addEventListener("resize", () => {
  document.dispatchEvent(new Event("theme:resize"));
});

window.addEventListener("load", () => {
  document.dispatchEvent(new Event("theme:load"));
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-animation]").forEach((el) => {
    new ParallaxHandler(el);
  });
});


class ScrollReveal {
	constructor(selector = ".expose", staggerDelay = 300) {
		this.selector = selector, this.staggerDelay = staggerDelay, this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
			root: null,
			threshold: .2
		}), this.initElements()
	}
	initElements(scope = document) {
		scope.querySelectorAll(this.selector).forEach(el => {
			el.dataset.revealed !== "true" && (el.style.opacity = 0, el.style.transform = "translateY(20px)", el.style.transition = "opacity 0.4s ease, transform 0.4s ease", this.observer.observe(el))
		})
	}
	staggerBatch(elements) {
		elements.forEach((el, index) => {
			setTimeout(() => {
				el.style.opacity = 1, el.style.transform = "translateY(0)", el.dataset.revealed = "true"
			}, index * this.staggerDelay), this.observer.unobserve(el)
		})
	}
	onIntersect(entries, observer) {
		entries.forEach(entry => {
			if (!entry.isIntersecting) return;
			const el = entry.target;
			if (el.classList.contains("delay")) {
				const siblings = Array.from(el.parentNode.querySelectorAll(".expose.delay")).filter(sib => sib.dataset.revealed !== "true");
				this.staggerBatch(siblings)
			} else el.style.opacity = 1, el.style.transform = "translateY(0)", el.dataset.revealed = "true", observer.unobserve(el)
		})
	}
}
let scrollReveal;
document.addEventListener("DOMContentLoaded", () => {
	scrollReveal = new ScrollReveal(".expose", 150)
}), document.addEventListener("shopify:section:load", () => {
	scrollReveal = new ScrollReveal(".expose", 150)
});



class BundleBuilder extends HTMLElement {
  constructor() {
    super();
    this.selected = {};
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll(".bundle-product");
    this.footerItems = this.querySelectorAll(".selected-items");
    this.totalEl = this.querySelector(".bundle-price");
    this.addBtn = this.querySelector(".bundle-add");
    this.form = this.querySelector(".bundle-form"); //  FIX

    this.init();

    // Delay swiper init
    setTimeout(() => {
      this.initSwiper();
    }, 200);
  }

  init() {
    // Product click
    this.buttons.forEach(btn => {
      btn.addEventListener("click", () => this.handleSelect(btn));
    });

    // Form submit (AJAX)
    if (this.form) {
      this.form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.submitForm();
      });
    }
  }

  //  SWIPER
  initSwiper() {
    if (typeof Swiper === "undefined") {
      setTimeout(() => this.initSwiper(), 100);
      return;
    }

    this.querySelectorAll(".bundle-products").forEach(slider => {

      if (slider.swiper) {
        slider.swiper.destroy(true, true);
      }

      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 12,
        grabCursor: true,
        observer: true,
        speed: 800,
        observeParents: true,
        pagination: {
          el: slider.querySelector(".bujdle_swipe_nav"),
          clickable: true
        }
      });
    });
  }

  //  SELECT PRODUCT
  handleSelect(btn) {
    const step = parseInt(btn.dataset.step);

    // Remove previous active
    this.querySelectorAll(`.bundle-product[data-step="${step}"]`)
      .forEach(b => b.classList.remove("active"));

    btn.classList.add("active");

    const data = {
      id: btn.dataset.variantId,
      price: parseInt(btn.dataset.price),
      image: btn.dataset.image
    };

    this.selected[step] = data;

    //  Update hidden inputs
    const footerItem = this.footerItems[step - 1];

    if (footerItem) {
      const idInput = footerItem.querySelector('input[name$="[id]"]');
      const qtyInput = footerItem.querySelector('input[name$="[quantity]"]');

      if (idInput && qtyInput) {
        idInput.value = data.id;
        idInput.disabled = false;

        qtyInput.value = 1;
        qtyInput.disabled = false;
      }
    }

    this.updateFooter();
    this.updateAddButton();
  }

  //  FOOTER UPDATE
  updateFooter() {
    let total = 0;

    this.footerItems.forEach((item, index) => {
      const step = index + 1;
      const data = this.selected[step];

      const placeholder = item.querySelector(".select-item_placeholder");
      const imageWrap = item.querySelector(".select_image_wrapper");

      if (data) {
        total += data.price;

        placeholder.classList.add("hidden");
        imageWrap.classList.remove("hidden");

        if (!imageWrap.querySelector("img")) {
          imageWrap.innerHTML = `<img src="${data.image}" alt="">`;
        } else {
          imageWrap.querySelector("img").src = data.image;
        }

      } else {
        placeholder.classList.remove("hidden");
        imageWrap.classList.add("hidden");
        imageWrap.innerHTML = "";
      }
    });

    this.totalEl.innerText = Shopify.formatMoney(total);
  }

  //  BUTTON STATE
  updateAddButton() {
    const activeCount = this.querySelectorAll(".bundle-product.active").length;
    const totalSteps = this.querySelectorAll(".bundle-step").length;

    this.addBtn.disabled = activeCount !== totalSteps;
  }

  //  AJAX SUBMIT
  submitForm() {
    const inputs = this.querySelectorAll('.selected-items');

    let index = 0;

    // Disable all first
    this.querySelectorAll('input[name^="items"]').forEach(input => {
      input.disabled = true;
    });

    // Re-index valid inputs
    inputs.forEach(item => {
      const idInput = item.querySelector('input[name$="[id]"]');
      const qtyInput = item.querySelector('input[name$="[quantity]"]');

      if (!idInput || !idInput.value) return;

      idInput.name = `items[${index}][id]`;
      qtyInput.name = `items[${index}][quantity]`;

      idInput.disabled = false;
      qtyInput.disabled = false;

      index++;
    });

    if (index === 0) {
      this.addBtn.disabled = false;
      return;
    }

    const formData = new FormData(this.form);

    this.addBtn.classList.add("loading");
    this.addBtn.disabled = true;

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData
    })
    .then(async (res) => {
      const data = await res.json();

    if (!res.ok) {
      throw new Error(data.description || "Cart error");
    }

    return data;
  })
  .then(async () => {

    const rawCartData = await fetch(
      window.Shopify.routes.root + "?sections=cart-drawer,cart-count,cart-main"
    ).then(res => res.json());

    const cartData = {
      sections: rawCartData,
      button: this.addBtn
    };

    document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: cartData,
            bubbles: true
          })
        );

      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        this.addBtn.classList.remove("loading");
        this.addBtn.disabled = false;
      });
    }

  //  RESET
  resetUI() {
    this.querySelectorAll(".bundle-product").forEach(btn => {
      btn.classList.remove("active");
    });

    this.selected = {};

    // Reset inputs
    this.querySelectorAll('input[name^="items"]').forEach(input => {
      input.value = "";
      input.disabled = true;
    });

    this.updateFooter();
    this.updateAddButton();
  }
}

if (!customElements.get("bundle-builder")) {
  customElements.define("bundle-builder", BundleBuilder);
}


class FadeObserver {
  constructor() {
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            this.observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );
  }

  observeElements(selector = '.fade-section') {
    document.querySelectorAll(selector).forEach(el => {
      this.observer.observe(el);
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const fade = new FadeObserver();
  fade.observeElements();
});


function initializeBeforeAfterSliders() {
  document.querySelectorAll('.before-after-container').forEach(container => {
    const imgAfter = container.querySelector('.before-after__img-wrapper:nth-child(2)');
    const line = container.querySelector('.before-after__line');
    const slider = container.querySelector('.before-after__slider');

    if (!slider || !imgAfter || !line) return;

    const value = slider.value || 50;
    line.style.left = `${value}%`;
    imgAfter.style.clipPath = `inset(0px 0px 0px ${value}%)`;

    slider.addEventListener('input', () => {
      const value = slider.value;
      line.style.left = `${value}%`;
      imgAfter.style.clipPath = `inset(0px 0px 0px ${value}%)`;
    });

    slider.addEventListener('dblclick', () => {
      slider.value = 50;
      line.style.left = '50%';
      imgAfter.style.clipPath = 'inset(0px 0px 0px 50%)';
    });
  });
}

document.addEventListener('DOMContentLoaded', initializeBeforeAfterSliders);
document.addEventListener('shopify:section:load', initializeBeforeAfterSliders);


class TopObserver {
  constructor() {
    this.sections = document.querySelectorAll('.top_observe');
    this.init();
  }

  init() {
    if (!this.sections.length) return;

    const options = {
      root: null,
      threshold: 0,
      rootMargin: '0px 0px -100% 0px'
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        } else {
          entry.target.classList.remove('active');
        }
      });
    }, options);

    this.sections.forEach(section => {
      this.observer.observe(section);
    });

    this.checkOnLoad();
  }

  checkOnLoad() {
    const scrollTop = window.scrollY || window.pageYOffset;

    this.sections.forEach(section => {
      const offsetTop = section.offsetTop;

      if (scrollTop >= offsetTop) {
        section.classList.add('active');
      } else {
        section.classList.remove('active');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new TopObserver();
});


class FaqTab extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('.faq-tab-button');
    this.contents = this.querySelectorAll('.faq-tab-content');

    this.init();
  }

  init() {
    if (!this.buttons.length || !this.contents.length) return;

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.handleTabClick(button);
      });
    });

    // Ensure first tab is active on load
    const activeButton = this.querySelector('.faq-tab-button.active') || this.buttons[0];
    if (activeButton) {
      this.handleTabClick(activeButton, false);
    }
  }

  handleTabClick(button, scroll = true) {
    const tabId = button.dataset.tab;

    // Remove active from all buttons
    this.buttons.forEach((btn) => btn.classList.remove('active'));

    // Hide all contents
    this.contents.forEach((content) => {
      content.style.display = 'none';
      content.classList.remove('active');
    });

    // Activate clicked button
    button.classList.add('active'); 

    // Show matching content
    const activeContent = this.querySelector(
      `.faq-tab-content[data-content="${tabId}"]`
    );

    if (activeContent) {
      activeContent.style.display = 'block';
      activeContent.classList.add('active');
    }
  }
}

customElements.define('faq-tab', FaqTab);

class AccordionComponent extends HTMLElement {
  constructor() {
    super();
    this.items = [];
  }

  connectedCallback() {
    this.items = this.querySelectorAll(':scope > details');

    this.items.forEach((item) => {
      const summary = item.querySelector(':scope > summary');
      const content = item.querySelector(':scope > .accordion__content');

      if (!summary || !content) return;

      // initial state
      if (item.hasAttribute('open')) {
        content.style.height = 'auto';
      } else {
        content.style.height = '0px';
        content.style.overflow = 'hidden';
      }

      summary.addEventListener('click', (e) => {
        e.preventDefault();

        // critical for nested accordions
        e.stopPropagation();

        const isOpen = item.hasAttribute('open');
        const singleOpen = this.dataset.singleOpen !== "false";

        // close siblings (same level only)
        if (singleOpen) {
          this.items.forEach((i) => {
            if (i !== item) this.close(i);
          });
        }

        if (isOpen) {
          this.close(item);
        } else {
          this.open(item);
        }
      });
    });
  }

  open(item) {
    const content = item.querySelector(':scope > .accordion__content');
    if (!content) return;

    item.setAttribute('open', true);

    content.style.overflow = 'hidden';
    content.style.height = '0px';

    const height = content.scrollHeight;

    requestAnimationFrame(() => {
      content.style.transition = 'height 300ms ease';
      content.style.height = height + 'px';
    });

    content.addEventListener(
      'transitionend',
      () => {
        content.style.height = '';
        content.style.overflow = '';
      },
      { once: true }
    );
  }

  close(item) {
    const content = item.querySelector(':scope > .accordion__content');
    if (!content) return;

    const height = content.scrollHeight;

    content.style.overflow = 'hidden';
    content.style.height = height + 'px';

    requestAnimationFrame(() => {
      content.style.transition = 'height 300ms ease';
      content.style.height = '0px';
    });

    content.addEventListener(
      'transitionend',
      () => {
        item.removeAttribute('open');
        content.style.height = '';
        content.style.overflow = '';
      },
      { once: true }
    );
  }
}

if (!customElements.get('accordion-component')) {
  customElements.define('accordion-component', AccordionComponent);
}

// Hero product spotlight
class HeroProductSpotlight extends HTMLElement {
  constructor() {
    super();

    this.swiper = null;
    this.initialized = false;
    this.observer = null;
    this.autoplayEnabled = false;
  }

  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;

    window.whenSwiperReady(() => {
      this.init();
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  init() {
    this.initTicker();
    this.initSwiper();
    this.observeVisibility();
  }

  initSwiper() {
    const slider = this.querySelector(".hero-product-spotlight__slider");

    if (!slider) return;

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    this.autoplayEnabled = this.dataset.autoplay === "true";

    const autoplaySpeed =
      Number(this.dataset.autoplaySpeed) || 5000;

    const transitionSpeed =
      Number(this.dataset.transitionSpeed) || 800;

    const options = {
      slidesPerView: 1,
      loop: true,
      effect: "fade",
      speed: transitionSpeed,

      fadeEffect: {
        crossFade: true
      },

      pagination: {
        el: this.querySelector(".hero-product-spotlight__pagination"),
        clickable: true,

        renderBullet(index, className) {
          return `
            <span class="${className}">
              <span class="hero-product-spotlight__bullet-progress"></span>
            </span>
          `;
        }
      },

      observer: true,
      observeParents: true,
      watchOverflow: true,

      on: {
        init: () => {
          this.animateSlide();
          this.updateOverlay(true);
          this.updateProgress();
        },

        slideChangeTransitionStart: () => {
          this.animateSlide();
          this.updateOverlay();
          this.resetProgress();
        },

        slideChangeTransitionEnd: () => {
          this.updateProgress();
        }
      }
    };

    if (this.autoplayEnabled) {
      options.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      };
    }

    this.swiper = new Swiper(slider, options);

    if (!this.autoplayEnabled && this.swiper.autoplay) {
      this.swiper.autoplay.stop();
    }
  }

  updateOverlay(initial = false) {
    if (!this.swiper) return;

    const activeSlide =
      this.swiper.slides[this.swiper.activeIndex];

    if (!activeSlide) return;

    const newSrc = activeSlide.dataset.overlay;

    const overlay =
      this.querySelector(".hero-product-spotlight__overlay-image");

    const placeholder =
      this.querySelector(".hero-product-spotlight__overlay-placeholder");

    if (!newSrc) {
      if (overlay) {
        overlay.classList.remove("is-visible");
        overlay.style.visibility = "hidden";
        delete overlay.dataset.current;
      }

      if (placeholder) {
        placeholder.classList.add("is-visible");
      }

      return;
    }

    if (placeholder) placeholder.classList.remove("is-visible");

    if (!overlay) return;

    if (overlay.dataset.current === newSrc) return;

    if (!initial) {
      overlay.classList.remove("is-visible");
    }

    const reveal = () => {
      overlay.dataset.current = newSrc;
      overlay.style.visibility = "";

      requestAnimationFrame(() => {
        overlay.classList.add("is-visible");
      });
    };

    // Load directly on the real, visible <img> instead of preloading through
    // a detached Image() object. A second Image() pointed at a src that's
    // already loading/loaded elsewhere in the DOM is where Firefox was being
    // unreliable (duplicate in-flight request handling); the real element's
    // own load/error events are the standard image-loading path and behave
    // consistently across browsers.
    if (overlay._heroOverlayLoadHandler) {
      overlay.removeEventListener("load", overlay._heroOverlayLoadHandler);
      overlay.removeEventListener("error", overlay._heroOverlayLoadHandler);
      overlay._heroOverlayLoadHandler = null;
    }

    const alreadyLoaded =
      overlay.getAttribute("src") === newSrc &&
      overlay.complete &&
      overlay.naturalWidth > 0;

    if (alreadyLoaded) {
      reveal();
      return;
    }

    const handler = () => {
      overlay.removeEventListener("load", handler);
      overlay.removeEventListener("error", handler);
      overlay._heroOverlayLoadHandler = null;
      reveal();
    };

    overlay._heroOverlayLoadHandler = handler;
    overlay.addEventListener("load", handler);
    overlay.addEventListener("error", handler);
    overlay.src = newSrc;
  }

  animateSlide() {
    const active =
      this.querySelector(".swiper-slide-active");

    if (!active) return;

    [
      active.querySelector(".hero-product-spotlight__content"),
      active.querySelector(".hero-product-spotlight__product")
    ].forEach((element) => {
      if (!element) return;

      element.classList.remove("is-visible");

      requestAnimationFrame(() => {
        element.classList.add("is-visible");
      });
    });
  }

  initTicker() {
    const track =
      this.querySelector(".hero-product-spotlight__ticker-track");

    if (!track || track.dataset.cloned) return;

    track.dataset.cloned = "true";
    track.innerHTML += track.innerHTML;
  }

  observeVisibility() {
    if (!("IntersectionObserver" in window)) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!this.swiper) return;
          if (!this.autoplayEnabled) return;
          if (!this.swiper.autoplay) return;

          if (entry.isIntersecting) {
            this.swiper.autoplay.start();
          } else {
            this.swiper.autoplay.stop();
          }
        });
      },
      {
        threshold: 0.25
      }
    );

    this.observer.observe(this);
  }

  resetProgress() {
    if (!this.autoplayEnabled) return;

    this.querySelectorAll(
      ".hero-product-spotlight__bullet-progress"
    ).forEach((bullet) => {
      bullet.style.animation = "none";
      void bullet.offsetWidth;
    });
  }

  updateProgress() {
    if (!this.swiper) return;
    if (!this.autoplayEnabled) return;

    this.querySelectorAll(
      ".hero-product-spotlight__bullet-progress"
    ).forEach((bullet) => {
      bullet.style.animation = "none";
    });

    const active = this.querySelector(
      ".swiper-pagination-bullet-active .hero-product-spotlight__bullet-progress"
    );

    if (!active) return;

    void active.offsetWidth;

    active.style.setProperty("--bullet-duration",`${this.dataset.autoplaySpeed}ms`);
  }
}

customElements.define(
  "hero-product-spotlight",
  HeroProductSpotlight
);

// Expandable Split Hero
class ExpandableSplitHero extends HTMLElement {
  constructor() {
    super();

    this.slides = [];
    this.activeIndex = 0;
    this.isMobile = window.matchMedia('(max-width: 990px)');
    this._resizeHandler = this.onResize.bind(this);
  }

  connectedCallback() {
    this.slides = [...this.querySelectorAll('.expandable-split-hero__slide')];

    if (!this.slides.length) return;

    this.setActive(0);

    this.bindEvents();

    window.addEventListener('resize', this._resizeHandler);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._resizeHandler);
  }

  bindEvents() {
  this.slides.forEach((slide, index) => {

    slide.addEventListener('mouseenter', () => {
      if (!this.isMobile.matches) {
        this.setActive(index);
      }
    });

    slide.addEventListener('focusin', () => {
      this.setActive(index);
    });

    slide.addEventListener('click', () => {
      if (this.isMobile.matches) {
        this.setActive(index);
      }
    });

  });

  // Reset to first slide when leaving the section
  this.addEventListener('mouseleave', () => {
    if (!this.isMobile.matches) {
      this.setActive(0);
    }
  });

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target.closest('.expandable-split-hero__slide');

    if (!block || !this.contains(block)) return;

    const index = this.slides.indexOf(block);

    if (index > -1) {
      this.setActive(index);
    }
  });
}

  setActive(index) {
    this.activeIndex = index;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
  }

  onResize() {
    if (this.isMobile.matches) {
      this.slides.forEach(slide => slide.classList.remove('is-active'));

      if (this.slides[0]) {
        this.slides[0].classList.add('is-active');
      }
    }
  }
}

customElements.define('expandable-split-hero', ExpandableSplitHero);

// Age verification
class AgeVerifier extends HTMLElement {
  constructor() {
    super();

    this.delay = Number(this.dataset.delay) || 0;
    this.minAge = Number(this.dataset.minAge) || 18;
    this.storageKey = this.dataset.storageKey || 'age_verified';

    this.yesButton = this.querySelector('[data-age-yes]');
    this.noButton = this.querySelector('[data-age-no]');
    this.errorMessage = this.querySelector('[data-age-error]');

    this.timer = null;
  }

  connectedCallback() {
    this.yesButton?.addEventListener('click', this.handleYes.bind(this));
    this.noButton?.addEventListener('click', this.handleNo.bind(this));

    this.init();
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }

  init() {
    const isVerified = localStorage.getItem(this.storageKey);

    if (isVerified === 'true') {
      this.remove();
      return;
    }

    this.timer = setTimeout(() => {
      this.show();
    }, this.delay);
  }

  show() {
    this.classList.add('active');

    this.setAttribute('aria-hidden', 'false');

    // Save current scroll position
    this.scrollPosition = window.scrollY;

    // Lock page scroll
    document.documentElement.classList.add('age-verifier-active');
    document.body.classList.add('age-verifier-active');

    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    this.yesButton?.focus();
  }

  handleYes() {
    localStorage.setItem(this.storageKey, 'true');

    this.hide();
  }

  handleNo() {
    if (this.errorMessage) {
      this.errorMessage.hidden = false;
    }

    this.classList.add('has-error');
  }

  hide() {
    this.classList.remove('active');

    this.setAttribute('aria-hidden', 'true');

    // Remove page scroll lock
    document.documentElement.classList.remove('age-verifier-active');
    document.body.classList.remove('age-verifier-active');

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    // Restore previous scroll position
    window.scrollTo(0, this.scrollPosition || 0);

    setTimeout(() => {
      this.remove();
    }, 300);
  }
}

customElements.define('age-verifier', AgeVerifier);
